<script>
export default {
  name: "documents",
  props: {
    categories: Array,
    docs: Array
  },
 data () {
    return {
      cat: this.categories,
      documents: this.docs
    }
 }
}
</script>

<template>
  <div class="documents">
    <div class="nr_container_content">
      <div class="documents__crumbs">
        <ul class="documents__crumbs-list">
          <li class="documents__crumbs-item" v-for="(link, idx) of cat" :key="idx">
            <a :href="link.path"
               class="documents__crumbs-link"
               :class="{'documents__crumbs-link--active': link.active}"
               v-text="link.name"
            />
          </li>
        </ul>
      </div>
      <div class="documents__cards">
        <div class="documents__cards-card"
             v-for="(link, idx) of documents"
             :key="idx"
        >
          <a :href="link.path" class="documents__cards-link" target="_blank" />
          <div class="documents__cards-card--container">
            <div class="documents__cards-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                <path d="M9 0C7.35 0 6 1.35 6 3V45C6 46.65 7.35 48 9 48H39C40.65 48 42 46.65 42 45V12L30 0H9Z" fill="#E2E5E7"/>
                <path d="M33 12H42L30 0V9C30 10.65 31.35 12 33 12Z" fill="#B0B7BD"/>
                <path d="M42 21L33 12H42V21Z" fill="#CAD1D8"/>
              </svg>
            </div>
            <span class="documents__cards-name" v-text="link.name" />
          </div>
          <span class="documents__cards-info">
            {{ link.date + ' | ' + link.fileType.toUpperCase() + ' ' + link.fileSize + 'мб' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "../../theme/variable";
.documents {
  width: 100%;
  margin-top: 40px;

  @media (max-width: 576px) {
    margin-top: 80px;
  }

  &__head {
    width: 100%;
    margin-bottom: 48px;

    @media (max-width: 767px) {
      margin-bottom: 24px;
    }
  }
  &__title {
    color: #F94237;
    font-family: 'MuseoSansCyrl-600';
    font-size: 64px;
    line-height: 100%;
    text-transform: uppercase;

    @media (max-width: 767px) {
      margin-bottom: 32px;
    }
  }

  &__crumbs {
    width: 100%;
    margin-bottom: 60px;

    @media (max-width: 767px) {
      margin-bottom: 30px;
    }

    &-list {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: start;
      gap: 10px;
      flex-wrap: wrap;
      margin: 0;
      padding: 0;
      list-style: none;
    }
    &-link {
      padding: 14px 20px;
      border-radius: 52px;
      background-color: #fff;
      transition: all .3s ease;
      text-decoration: none;
      font-size: 16px;
      line-height: 100%;
      letter-spacing: 0.08px;
      display: block;

      &:not(&--active) {
        border: 1px solid #dfdfdf;
        color: #404040;

        &:hover {
          border-color: #F94237;
        }
      }
      
      &--active {
        color: #ffffff;
        background-color: #F94237;
      }
    }

  }
  &__cards {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 60px;
    align-items: stretch;

    @media (max-width: 767px) {
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 30px;
    }

    @media (max-width: 576px) {
      grid-template-columns: repeat(1, 1fr);
    }

    &-card {
      width: 100%;
      border-radius: 20px;
      background-color: #FFF;
      box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.06);
      padding: 20px;
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: space-between;
      gap: 48px;
      position: relative;
      pointer-events: none;
      transition: all .3s ease;

      &:hover {
        .documents__cards-name {
          color: #F94237;
        }
      }

      &--container {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: start;
        gap: 20px;
      }
    }
    &-link {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      pointer-events: auto;
    }
    &-icon {
      min-width: 48px;
      width: 48px;
      height: 48px;
    }
    &-name {
      color: #282828;
      font-size: 18px;
      line-height: 24px;
      transition: all .3s ease;
    }
    &-info {
      color: #646464;
      font-family: 'RobotoRegular', sans-serif;
      font-size: 14px;
      line-height: 16px;
    }
  }
}
</style>